import { useRef} from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useGetBlogById } from '../functions/blogHook';
import AdvertisementSidebar from '../components/newsletter/Adcolumn';
import RelatedPosts from '../components/blog/blogRelated';
import DiscussionSection from '../components/blog/DisccussionSection';
import CommentsList from '../components/blog/commentList';
import Sidebar from '../components/blog/Sidebar';

// Skeleton Loader Component
const SkeletonLoader = () => (
  <div className="animate-pulse">
    <div className="h-8 bg-gray-300 rounded w-3/4 mb-4"></div>
    <div className="h-64 bg-gray-300 rounded mb-4"></div>
    <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
    <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
    <div className="h-4 bg-gray-300 rounded w-2/3"></div>
  </div>
);

export function BlogPost() {
  const { id } = useParams<{ id: string }>();
  const mainContentRef = useRef<HTMLDivElement | null>(null);

  // Log the initial 'id' from the URL params
  console.log("Received blog ID from URL params:", id);

 

  // Avoid making API call before the id is valid
  const { blog, isLoading, isError } = useGetBlogById(id || '');

  // Log API call status

 

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <SkeletonLoader />
      </div>
    );
  }

  <h1 className="text-2xl font-bold text-red-600">{id}</h1>


  if (isError || !blog) {
    console.error("Error or no blog found:", blog);
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl font-bold text-red-600">Blog not found</h1>
      </div>
    );
  }

  const adaptedBlog = {
    id: blog._id,
    title: blog.title,
    content: blog.details || "",
    imageUrl: blog.images?.[0] || "",
    date: blog.publicationDate,
    author: blog.author,
    specialty: blog.authorSpecialty,
    readTime: blog.readTime,
    tags: blog.tags,
    category: blog.category,
    authorName:blog.authorName
  };

  console.log("Adapted blog data:", adaptedBlog);

  const contentSections = [
    { id: 'introduction', title: 'Introduction' },
    { id: 'main-content', title: 'Main Content' },
    { id: 'conclusion', title: 'Conclusion' },
    { id: 'discussion', title: 'Discussion' },
    { id: 'related', title: 'Related Posts' },
  ];

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section && mainContentRef.current) {
      const sectionPosition = section.offsetTop - 20;
      console.log(`Scrolling to section: ${sectionId}, Position: ${sectionPosition}`);
      mainContentRef.current.scrollTo({
        top: sectionPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-navy-900 text-white py-6 px-4">
        <div className="container mx-auto">
          <Link to="/" className="inline-flex items-center text-gray-200 hover:text-white">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to blog
          </Link>
        </div>
      </header>

      {/* Main Content Area */}
      <div className="flex-1 flex overflow-hidden">
        {/* Left Sidebar */}
        <Sidebar
  contentSections={contentSections}
  post={adaptedBlog}
  scrollToSection={scrollToSection}
  className="hidden md:block" // Oculta en móviles y muestra en pantallas medianas y grandes
/>

        {/* Main Content */}
        <main ref={mainContentRef} className="flex-1 overflow-y-auto relative">
          <div className="max-w-3xl mx-auto px-8 py-6">
            <section id="introduction">
              <h1 className=" text-2xl md:text-4xl font-bold text-gray-900 mb-6">{adaptedBlog.title}</h1>
              {adaptedBlog.imageUrl ? (
                <img
                  src={adaptedBlog.imageUrl}
                  alt={adaptedBlog.title}
                  className="w-full h-[400px] object-cover rounded-lg shadow-lg mb-8"
                />
              ) : (
                <SkeletonLoader />
              )}
            </section>

            <section id="main-content" className="mb-12">
              <div className="prose prose-lg max-w-none">
                {adaptedBlog.content
                  ? adaptedBlog.content.split('\n\n').map((paragraph: string, index: number) => (
                      <p key={index} className="mb-6 text-gray-700 leading-relaxed">
                        {paragraph.trim()}
                      </p>
                    ))
                  : <SkeletonLoader />}
              </div>
            </section>

            <section id="conclusion" className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Conclusion</h2>
              <p className="text-gray-700">
                This article has explored the key concepts and implementation details of the topic.
                We hope you found this information helpful and practical for your needs.
              </p>
            </section>

            <RelatedPosts blogId={adaptedBlog.id} />

            {/* Discussion Section */}
            <section id="discussion" className="mt-16 border-t border-gray-200 pt-8">
              <DiscussionSection blogId={adaptedBlog.id} />
              <CommentsList blogId={adaptedBlog.id} />
            </section>
          </div>
        </main>

        <AdvertisementSidebar />
      </div>
    </div>
  );
}
